import { render } from "./OrganPipesMap.vue?vue&type=template&id=6f38079d&scoped=true"
import script from "./OrganPipesMap.vue?vue&type=script&lang=js"
export * from "./OrganPipesMap.vue?vue&type=script&lang=js"

import "./OrganPipesMap.vue?vue&type=style&index=0&id=6f38079d&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f38079d"]])

export default __exports__